import { CircularProgress, Stack, Typography } from '@mui/material';
import useLocalization from '../../../hooks/useLocalization';

const styles = {
  root: {
    alignItems: 'center',
    textAlign: 'center',
    gap: 1,
    px: 2,
    py: 3,
  },
  indicator: {
    mb: 1.5,
    color: 'primary.main',
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
      '& .MuiCircularProgress-circle': { animation: 'none' },
    },
  },
  title: {
    m: 0,
    fontWeight: 600,
    letterSpacing: 0,
    lineHeight: 1.4,
    color: 'text.primary',
  },
  description: {
    maxWidth: '32ch',
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: 1.65,
    color: 'text.secondary',
  },
};

const FinpspReceivingNumberWaiting = () => {
  const { t } = useLocalization();

  return (
    <Stack direction='column' role='status' sx={styles.root}>
      <CircularProgress size={28} thickness={3} disableShrink aria-hidden='true' sx={styles.indicator} />
      <Typography component='h3' variant='body1' sx={styles.title}>
        {t('finpspAssigningNumber')}
      </Typography>
      <Typography variant='body2' sx={styles.description}>
        {t('finpspReceivingNumberPending')}
      </Typography>
    </Stack>
  );
};

export default FinpspReceivingNumberWaiting;
